import React, { useState } from 'react';
import { saveAs } from 'file-saver'

interface Istate {
  IColorOptions: {
    id: number
    colorName: string
    colorCode: string
    colorIsActive: Boolean
  }
}

function App() {

  const initialColorOptions = [
    {
      id: 144,
      colorName: 'Blue',
      colorCode: '383870',
      colorIsActive: false,
    },
    {
      id: 133,
      colorName: 'Red',
      colorCode: 'eb2d56',
      colorIsActive: false,
    },
    {
      id: 122,
      colorName: 'White',
      colorCode: 'f6f3f3',
      colorIsActive: false,
    },
    {
      id: 19,
      colorName: 'Yellow',
      colorCode: 'ffd900',
      colorIsActive: false,
    },
    {
      id: 18,
      colorName: 'Green',
      colorCode: '04d39f',
      colorIsActive: false,
    },
    {
      id: 17,
      colorName: 'Black',
      colorCode: '1d1d1d',
      colorIsActive: false,
    },
    {
      id: 16,
      colorName: 'Orange',
      colorCode: 'f17035',
      colorIsActive: false,
    },
    {
      id: 15,
      colorName: 'Purple',
      colorCode: '862deb',
      colorIsActive: false,
    },
    {
      id: 14,
      colorName: 'Skyblue',
      colorCode: '08d8f3',
      colorIsActive: false,
    },
    {
      id: 13,
      colorName: 'Pink',
      colorCode: 'ff009d',
      colorIsActive: false,
    },
    {
      id: 12,
      colorName: 'Gray',
      colorCode: '464646',
      colorIsActive: false,
    },
    {
      id: 1,
      colorName: 'LightGray',
      colorCode: 'dbdbdb',
      colorIsActive: false,
    }
  ]

  const [qrcode, setQrCode] = useState(''),
        [liveQrCode, setLiveQrCode] = useState(''),
        [generate, setGenerate] = useState(false),
        [colorOptions, setColorOptions] = useState(initialColorOptions),
        [backgroundColorOptions, setBackgroundColorOptions] = useState(initialColorOptions),
        [color, setColor] = useState(''),
        [bgColor, setBgColor] = useState('')

  const generateQR = () => {
    const removeQR = () => {
      setGenerate(false)
      setLiveQrCode('')
      setQrCode('')
    }

    const generateQR = () => {
      setGenerate(true)
      setLiveQrCode(qrcode)
    }

    generate ? removeQR() : generateQR()
  }

  const downloadQR = () => liveQrCode !== '' ? saveAs(`https://api.qrserver.com/v1/create-qr-code/?data=${liveQrCode}&color=${color}&bgcolor=${bgColor}`, 'image.jpg') : alert('No Generated QR Code to Download')

  const colorIsPicked = (colorParam:Istate['IColorOptions'], option:string) => {

    switch (option) {
      case 'color':
        setColor(colorParam.colorCode)
        setColorOptions(colorOptions.map(color => color.colorName !== colorParam.colorName ? {...color, colorIsActive:false } : {...color, colorIsActive:true} ))
        break;

      case 'bgColor':
        setBgColor(colorParam.colorCode)
        setBackgroundColorOptions(backgroundColorOptions.map(bgColor => bgColor.colorName !== colorParam.colorName ? {...bgColor, colorIsActive: false} : {...bgColor, colorIsActive: true}))
        break;

      default:
        break;
    }
  }

  return (
    <div className="qrly">
      <h1 className="qrly-title"> <span>QR</span>LY </h1>
      <div className="qrly-content">
        <div className="qrly-container">
          <p className="qrly-subtitle"> Color </p>
          <ul className="qrly-color-list">
            { 
              colorOptions.map((c:Istate['IColorOptions']) => {
                return(
                  bgColor !== (c.colorCode) ?
                  <li key={c.id} onClick={() => colorIsPicked(c, 'color')} className={`qrly-color-list__item qrly-color-list__item--${c.colorName} ${c.colorIsActive && 'qrly-color-list__item--active'}`}></li> :
                  <li key={c.id} className={`qrly-color-list__item qrly-color-list__item--${c.colorName} qrly-color-list__item--disabled`}></li>
                )
              })
            }
          </ul>

          <p className="qrly-subtitle"> Background Color </p>

          <ul className="qrly-color-list">
            { 
              backgroundColorOptions.map(c => {
                return(
                  color !== (c.colorCode) ?
                  <li key={c.id} onClick={() => colorIsPicked(c, 'bgColor')} className={`qrly-color-list__item qrly-color-list__item--${c.colorName} ${c.colorIsActive && 'qrly-color-list__item--active'}`}></li> :
                  <li key={c.id} className={`qrly-color-list__item qrly-color-list__item--${c.colorName} qrly-color-list__item--disabled`}></li>
                )
              })
            }
          </ul>
        </div>

        <div className="qrly-container">
          <div className="qrly-image-container">
            {
              generate && <img className="qrly-image" src={`https://api.qrserver.com/v1/create-qr-code/?data=${liveQrCode}&color=${color}&bgcolor=${bgColor}`} alt='qrCode'/>
            }
          </div>
          <div className="qrly-flex-container">
            <input value={qrcode} className="qrly-input" type="text" onChange={(e => setQrCode(e.target.value))}/>
            <button className="qrly-button" onClick={generateQR}> { generate ? 'Remove QR' :'Generate QR' } </button>
          </div>
          <button className="qrly-button qrly-button--download" onClick={downloadQR}> Download QR </button>
        </div>
      </div>
      <footer className="footer">
          <p className="qrly-text"> Designed and Developed by <a className="qrly-text--link" href="https://paolomartinligsay.netlify.app/" target="_blank"> Paolo Ligsay </a> </p>
        </footer>
    </div>
  );
}

export default App;
